import { SignUp, useAuth } from '@clerk/react';
import { CircularProgress, Container, Typography } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { hasClerkInvitationTicket } from '../utils/auth';

const InvitationPage = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress aria-label="Loading invitation" />
      </div>
    );
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!hasClerkInvitationTicket(location.search, location.hash)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        pt: 14,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Accept your NILUS invitation
      </Typography>
      <Typography color="text.secondary" align="center" sx={{ mb: 3 }}>
        Create a password for the invited email to open your sponsor dashboard.
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <SignUp
          routing="path"
          path="/invitation"
          forceRedirectUrl="/dashboard"
          fallbackRedirectUrl="/dashboard"
        />
      </div>
    </Container>
  );
};

export default InvitationPage;
